import { FC, useMemo, useState } from "react";
import CardCustom from "../../components/card";
import TitleValue from "../../components/title-value";
import CardBasicCustom from "../../components/card-basic";
import "./home.css";
import useFetchStatistics from "../../service/userStatistics/getStatistic";
import { faChartSimple } from "@fortawesome/free-solid-svg-icons";
import { CardBasicCustomProps } from "../../model/custom-card-basic";
import InfoIcon from "@mui/icons-material/Info";
import useFetchStatisticsPerMonth from "../../service/userStatistics/getStatisticPerMonth";
import { Box, Grid, Paper, Typography, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, IconButton } from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import useFetchMonthStatistics from "../../service/userStatistics/getStatisticPerMonth";
import { useFetchTopDepositors } from "../../service/userStatistics/getStatisticTopUser";
import useFetchMonthlyCommission from "../../service/userStatistics/getMonthlyCommission";
import useFetchDailyCommission from "../../service/userStatistics/getDailyCommission";

import CommissionMonthlyChart from "../../components/charts/commissionMonthly";
import CommissionDailyChart from "../../components/charts/commissionDaily";
import TransactionsMonthlyChart from "../../components/charts/transactionsMonthly";
import { formatearPesoMXN } from "../../utils/format";
import { InputDatePicker } from "../../components/inputsDatePicker/inputDatePicker";
import TransactionTotalMonthly from "../../components/charts/transactionTotalMonthly";
import useFetchTotalTransaction from "../../service/userStatistics/getTotalTransaction";

const Home: FC = () => {
  //const { balances } = useFetchMonthlyBalances();
  const { monthStatistics, loading, error } = useFetchMonthStatistics();
  const { statistics } = useFetchStatistics();
  const { topDepositors, loading: loadingDepositors } = useFetchTopDepositors();
  const { monthlyCommission, loading: loadingCommission } = useFetchMonthlyCommission();
  const { dailyCommission, loading: loadingDailyCommission } = useFetchDailyCommission();
  const { totalTransaction, loading: loadingTotalTransaction } = useFetchTotalTransaction();

  const [startDateCommission, setStartDateCommission] = useState<Date | null>(null);
  const [endDateCommission, setEndDateCommission] = useState<Date | null>(null);

  const [startDateDaily, setStartDateDaily] = useState<Date | null>(null);
  const [endDateDaily, setEndDateDaily] = useState<Date | null>(null);

  const [startDateTransactions, setStartDateTransactions] = useState<Date | null>(null);
  const [endDateTransactions, setEndDateTransactions] = useState<Date | null>(null);


  const [startDatetTotalTransactions, setStartTotalTransaction] = useState<Date | null>(null);
  const [endDateTotalTransactions, setEndDateTotalTransaction] = useState<Date | null>(null);

  const handleClearCommissionFilters = () => {
    setStartDateCommission(null);
    setEndDateCommission(null);
  };

    const handleClearTotalTransactionFilters = () => {
    setStartTotalTransaction(null);
    setEndDateTotalTransaction(null);
  };


  const handleClearDailyFilters = () => {
    setStartDateDaily(null);
    setEndDateDaily(null);
  };

  const handleClearTransactionsFilters = () => {
    setStartDateTransactions(null);
    setEndDateTransactions(null);
  };

  const dataCard: CardBasicCustomProps[] = [
    {
      icon: faChartSimple,
      iconTooltip: <InfoIcon />,
      titleTooltip:
        "Este valor representa el monto total de las transacciones aprobadas durante mes. Indica cuánto se ha cargado exitosamente a las tarjetas de tus clientes.",

      value: `
      ${formatearPesoMXN(
        statistics?.response[0]?.currentMonth[0]
          ?.total_transaccion_current_month_without_comission
      )}`,
      description:
        "Total de cargos en mes actual: " +
        `${statistics?.response[0]?.currentMonth[0]?.total_transaccion_current_month}`,
      classCustom: "card-first",
    },

    {
      icon: faChartSimple,
      iconTooltip: <InfoIcon />,
      titleTooltip:
        "Este valor representa el monto total de las transacciones aprobadas durante mes pasado. Indica cuánto se ha cargado exitosamente a las tarjetas de tus clientes.",
      value: `
      ${formatearPesoMXN(
        statistics?.response[0]?.lastMonth[0]
          ?.total_transaccion_last_month_without_comission
      )}`,

      description:
        "Total de Cargos en el mes anterior: " +
        `${statistics?.response[0]?.lastMonth[0]?.total_transaccion_last_month}`,

      classCustom: "card-first",
    },
  ];
  return (
    <div className="home">
      <div className="section1">
        <CardCustom>
          {/* <TitleValue title="Cargos totales mes actual" value={totalAmount} /> */}
          <div className="cards_home">
            {dataCard.map((card, index) => (
              <CardBasicCustom
                iconTooltip={card.iconTooltip}
                titleTooltip={card.titleTooltip}
                icon={card.icon}
                value={card.value}
                description={card.description}
                info={card.info}
                key={index}
                classCustom={card.classCustom}
              />
            ))}
          </div>
        </CardCustom>
      </div>
      <Grid
        container
        spacing={2}
        sx={{ width: "100%", m: 0, mt: 2, minWidth: 0 }}
      >
        {/* Gráfico 1 */}
        {/* <Grid item xs={12} md={6} lg={8}>
          <Paper elevation={2} sx={{ p: 2 }}>
            <Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
              <InputDatePicker
                startDate={startDateTransactions}
                setStartDate={setStartDateTransactions}
                endDate={endDateTransactions}
                setEndDate={setEndDateTransactions}
              />
              <IconButton
                onClick={handleClearTransactionsFilters}
                color="primary"
                sx={{
                  border: '1px solid #1976d2',
                  borderRadius: '8px',
                  padding: '8px',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
                title="Limpiar filtros"
              >
                <CleaningServicesIcon />
              </IconButton>
            </Box>
            {loading ? (
              <Typography>Cargando transacciones...</Typography>
            ) : monthStatistics?.response && monthStatistics.response.length > 0 ? (
              <TransactionsMonthlyChart
                data={monthStatistics.response}
                startDate={startDateTransactions}
                endDate={endDateTransactions}
              />
            ) : (
              <Typography>No hay datos de transacciones disponibles</Typography>
            )}
          </Paper>
        </Grid> */}

                <Grid item xs={12} md={6} lg={6} sx={{ minWidth: 0 }}>
                  <Paper elevation={2} sx={{ p: { xs: 1.5, sm: 2 }, minWidth: 0 }}>
                    <Box sx={{ mb: 2, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
              <InputDatePicker
                startDate={startDatetTotalTransactions}
                setStartDate={setEndDateTotalTransaction}
                endDate={endDateTotalTransactions}
                setEndDate={setEndDateTotalTransaction}
              />
              <IconButton
                onClick={handleClearTotalTransactionFilters}
                color="primary"
                sx={{
                  border: '1px solid #1976d2',
                  borderRadius: '8px',
                  padding: '8px',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
                title="Limpiar filtros"
              >
                <CleaningServicesIcon />
              </IconButton>
            </Box>
            {loadingTotalTransaction ? (
              <Typography>Cargando comisiones...</Typography>
            ) : totalTransaction && totalTransaction.length > 0 ? (
              <TransactionTotalMonthly
                data={totalTransaction}
                startDate={startDateCommission}
                endDate={endDateCommission}
              />
            ) : (
              <Typography>No hay datos de comisiones disponibles</Typography>
            )}
          </Paper>
        </Grid>


        <Grid item xs={12} md={6} lg={6} sx={{ minWidth: 0 }}>
          <Paper elevation={2} sx={{ p: { xs: 1.5, sm: 2 }, minWidth: 0 }}>
            <Box sx={{ mb: 2, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
              <InputDatePicker
                startDate={startDateCommission}
                setStartDate={setStartDateCommission}
                endDate={endDateCommission}
                setEndDate={setEndDateCommission}
              />
              <IconButton
                onClick={handleClearCommissionFilters}
                color="primary"
                sx={{
                  border: '1px solid #1976d2',
                  borderRadius: '8px',
                  padding: '8px',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
                title="Limpiar filtros"
              >
                <CleaningServicesIcon />
              </IconButton>
            </Box>
            {loadingCommission ? (
              <Typography>Cargando comisiones...</Typography>
            ) : monthlyCommission && monthlyCommission.length > 0 ? (
              <CommissionMonthlyChart
                data={monthlyCommission}
                startDate={startDateCommission}
                endDate={endDateCommission}
              />
            ) : (
              <Typography>No hay datos de comisiones disponibles</Typography>
            )}
          </Paper>
        </Grid>


        <Grid item xs={12} md={6} lg={6} sx={{ minWidth: 0 }}>
          <Paper elevation={2} sx={{ p: { xs: 1.5, sm: 2 }, minWidth: 0 }}>
            <Box sx={{ mb: 2, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
              <InputDatePicker
                startDate={startDateDaily}
                setStartDate={setStartDateDaily}
                endDate={endDateDaily}
                setEndDate={setEndDateDaily}
              />
              <IconButton
                onClick={handleClearDailyFilters}
                color="primary"
                sx={{
                  border: '1px solid #1976d2',
                  borderRadius: '8px',
                  padding: '8px',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
                title="Limpiar filtros"
              >
                <CleaningServicesIcon />
              </IconButton>
            </Box>
            {loadingDailyCommission ? (
              <Typography>Cargando comisiones diarias...</Typography>
            ) : dailyCommission && dailyCommission.length > 0 ? (
              <CommissionDailyChart
                data={dailyCommission}
                startDate={startDateDaily}
                endDate={endDateDaily}
              />
            ) : (
              <Typography>No hay datos de comisiones diarias disponibles</Typography>
            )}
          </Paper>
        </Grid>

      </Grid>
    </div>
  );
};

export default Home;